export class ModeloDocumentacaoReadaptacaoDTO {
  id: string;
  nomeDocumento: string;
  ano: number;
  equipeTecnica: string;
  palavrasChave: string;
  descricao: string;
  versao: string;
  ativo: boolean;
  arquivoUrl?: string;
  arquivoNome?: string;
  documento: ModeloDocumentacaoReadaptacaoResponseDTO;
  dataUltimaAlteracao: string;
  ultimoResponsavel: string;

  constructor(obj: any) {
    if (obj) {
      this.id = obj.id;
      this.nomeDocumento = obj.nomeDocumento;
      this.ano = obj.ano;
      this.equipeTecnica = obj.equipeTecnica;
      this.palavrasChave = obj.palavrasChave;
      this.descricao = obj.descricao;
      this.versao = obj.versao;
      this.ativo = obj.ativo;
      this.arquivoUrl = obj.arquivoUrl;
      this.arquivoNome = obj.arquivoNome;
      this.documento = new ModeloDocumentacaoReadaptacaoResponseDTO(
        obj.documento
      );
      this.dataUltimaAlteracao = obj.dataUltimaAlteracao;
      this.ultimoResponsavel = obj.ultimoResponsavel;
    }
  }
}

export class ModeloDocumentacaoReadaptacaoResponseDTO {
  id: string;
  nome: string;
  extensao: string;
  caminhoArquivo: string;
  nomeOriginal: string;
  acao: string;

  constructor(obj: any) {
    if (obj) {
        this.id = obj.id;
        this.nome = obj.nome;
        this.extensao = obj.extensao;
        this.caminhoArquivo = obj.caminhoArquivo;
        this.nomeOriginal = obj.nomeOriginal;
        this.acao = obj.acao;
    }
  }
}
